import { Component, OnInit } from '@angular/core';
import { StateService } from '../../services/state.service';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  constructor(private stateSvc: StateService, private apiSvc: ApiService, private authSvc: AuthService) { }

  ngOnInit(): void {
  }
  
  /**
   * function to logout
   */
  logout(){
	let masterUser = sessionStorage.getItem('master-user');
	if(masterUser) {
		this.authSvc.login(masterUser, this.authSvc.reversHashBlowfish('7967820340147F45'))
		.subscribe((user:any) => {
			sessionStorage.removeItem('master-user');
			if(localStorage.getItem('markerShown')){
					localStorage.removeItem('markerShown');
				}
			if(localStorage.getItem('jump_direct')){
					localStorage.removeItem('jump_direct');
				}
				// clear trip time range
				if(localStorage.getItem('trip-start')){
					localStorage.removeItem('trip-start');
				}
				if(localStorage.getItem('trip-end')){
					localStorage.removeItem('trip-end');
				}
			if(localStorage.getItem('user-vehicle-ids')){
				localStorage.removeItem('user-vehicle-ids');
			}
			if(localStorage.getItem('OncoreMapProvider')){
				localStorage.removeItem('OncoreMapProvider');
				this.stateSvc.setMapType("OpenStreetMap");
			}
			if(user.subaccount) {
				user.hash = this.authSvc.hashBlowfish(user.subaccountowner);
				user.owner = user.subaccountowner;
			}
			// master account
			if(user.superuser){
				let tempObj = (user.supernames).split('|');
				user.masterusernames = tempObj;
			}
			sessionStorage.setItem('user', JSON.stringify(user));
			window.location.reload(true);
		});
	} else {
		this.stateSvc.logout();
	}
  }
  
  toggleFleetList(){
	  
  }
  
  /**
   * navigate to which page
   */
  navigatePage(page){
	this.apiSvc.navigateInternal(page);
  }

}
